import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hardback } from '@/components/landing/hardback/hardback'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='The Founders Shelf'
                description='An interactive 3D bookshelf of twelve essential reads on building, growing, and lasting companies. Pull one from the shelf and open it.'
            />

            <Hardback />
        </Layout>
    )
}

export default Home
